import { Component, Input, OnInit, OnDestroy, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
import { FormControl } from '@angular/forms';
import flatpickr from 'flatpickr';

@Component({
  selector: 'digi-time-picker',
  templateUrl: './input-time-picker.component.html',
  styleUrl: './input-time-picker.component.scss'
})
export class InputTimePickerComponent implements OnInit, OnDestroy {
  @Input() control!: FormControl;
  @Input() placeholder: string = 'Chọn giờ';
  @Input() minTime: string = '00:00';
  @Input() maxTime: string = '23:59';
  @Input() step: number = 15; // Bước nhảy phút
  @Input() hasError: boolean = false; // Trạng thái lỗi

  @Output() blur = new EventEmitter<any>();

  @ViewChild('timeInput', { static: true }) timeInput!: ElementRef<HTMLInputElement>;

  private flatpickrInstance: flatpickr.Instance | null = null;

  ngOnInit() {
    this.initFlatpickr();
  }

  ngOnDestroy() {
    if (this.flatpickrInstance) {
      this.flatpickrInstance.destroy();
    }
  }

  private initFlatpickr() {
    if (this.timeInput?.nativeElement) {
      this.flatpickrInstance = flatpickr(this.timeInput.nativeElement, {
        enableTime: true,
        noCalendar: true,
        dateFormat: "H:i",
        time_24hr: true,
        minuteIncrement: this.step,
        minTime: this.minTime,
        maxTime: this.maxTime,
        onChange: (selectedDates, dateStr) => {
          this.control.setValue(dateStr);
          // Emit blur event ngay khi có thay đổi để trigger validation
          setTimeout(() => {
            this.blur.emit();
          }, 100);
        },
        onClose: () => {
          this.control.markAsTouched();
          // Emit blur event khi đóng picker
          setTimeout(() => {
            this.blur.emit();
          }, 100);
        }
      });

      // Set initial value if control has value
      if (this.control.value) {
        this.flatpickrInstance.setDate(this.control.value, false);
      }

      // Listen to control value changes
      this.control.valueChanges.subscribe(value => {
        if (value && this.flatpickrInstance) {
          this.flatpickrInstance.setDate(value, false);
        }
      });
    }
  }
}